import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ApiRoutes} from "../../../services/apiroutes";
import {RequestApiService} from "../../../services/domain_code/request-api.service";
import {CommonService} from "../../../common.service";
import {OneWayQuoteTableService} from "../quoteTable/oneway-quote-table/oneway-quote-table.service";
import {TradeQuoteTableService} from "../quoteTable/trade-quote-table/trade-quote-table.service";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {RequestServeComponent} from "../request-serve/request-serve.component";
import {
    SendEmailConfirmationComponent
} from "../../dialog-box/send-email-confirmation/send-email-confirmation.component";
import {FailureBoxComponent} from "../../dialog-box/failure-box/failure-box.component";
import {WarningBoxComponent} from "../../dialog-box/warning-box/warning-box.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BookingChargesComponent} from "../booking-charges/booking-charges.component";

@Component({
    selector: 'logzy-oneway-trade-after-confirmation',
    templateUrl: './oneway-trade-after-confirmation.component.html',
    styleUrls: ['./oneway-trade-after-confirmation.component.scss']
})
export class OnewayTradeAfterConfirmationComponent implements OnInit {
    @Input()
    commercials;

    @Input()
    bookingDetails;

    @Input()
    reviewing: boolean = false;
    @Input()
    HeaderSet: boolean = true;

    @Output()
    closeReview = new EventEmitter();

    @Output()
    reqContainers = new EventEmitter();
    @Output()
    reopenLogs = new EventEmitter();
    @Output()
    bookingViewLogs = new EventEmitter();
    @Output()
    addInvoiceParty = new EventEmitter();
    downloadQuoteToolTip: string = "Download Quote";
    currentDate = new Date();
    additionalDetailsExpand: boolean = true;
    disableSaveButton: boolean = false;

    @Input()
    reviewQuote: boolean = false;
    remarks: string;

    downloadUrl = ApiRoutes.LeadRequest;

    edit: boolean = false;
    location_url = `${ApiRoutes.Location}?location_type_name=port&search=::search::`;
    containerConditionLists = `${ApiRoutes.DomainCode}?group=ContainerCondition`;
    containerSizeTypeUrl = `${ApiRoutes.ContainerMaster}container_size_type/?search=::search::`
    // bookingDetailsExpand: boolean = true;
    additionalCharges: any[] = [];
    allErrorsFromApi: string[] = [];

    @ViewChild(BookingChargesComponent) bookingChargesComponent!: BookingChargesComponent;

    constructor(public requestService: RequestApiService,
                public commonService: CommonService,
                private oneWayQuoteTableService: OneWayQuoteTableService,
                private tradeQuoteTableService: TradeQuoteTableService,
                private dialog: MatDialog,
                private router: Router,
                private requestServeComponent: RequestServeComponent,
                private snackBar: MatSnackBar
    ) {
    }

    ngOnInit(): void {
        if (this.reviewing == true) {
            this.reviewQuote = true;
        } else if (this.reviewing == false && this.HeaderSet == true) {
            this.downloadQuoteToolTip = "Download Smart Contract"
        }
        this.commonService.quotationData = this.commercials;
        this.scrolltop();
        this.getGlobalPreferences();

    }

    scrolltop() {
        setTimeout(() => {
            document.getElementById("top")?.scrollIntoView({block: "start", behavior: "smooth"});
        }, 200);
    }

    // Post Quote
    saveQuote() {
        this.disableSaveButton = true;
        if (this.requestService.selectedRequest.request_type.dev_name == 'one_way') {
            this.oneWayQuoteTableService.baseQuote.remarks = this.remarks;

            this.oneWayQuoteTableService.saveQuotation().then(data => {
                this.openSendQuoteConfirmationDialog(data['id'], 'oneway', 'Quote email sent', 'quote');
                // this.closeReview.emit(true);
            }).catch(error => {
                this.closeReview.emit(false);
            });
        }
        if (this.requestService.selectedRequest.request_type.dev_name == 'buy_sell') {
            this.tradeQuoteTableService.baseQuote.remarks = this.remarks;

            this.tradeQuoteTableService.saveQuotation().then(data => {
                this.openSendQuoteConfirmationDialog(data['id'], 'trade', 'Quote email sent', 'quote');
                // this.closeReview.emit(true);
            }).catch(error => {
                this.closeReview.emit(false);
            });
        }
    }

    openSendQuoteConfirmationDialog(quoteId, type, snackBarMessage, mailType): void {
        let htmlContent: string = '';
        this.requestService.getQuoteContentForEmail(quoteId, type, mailType).subscribe(
            (response: string) => {
                htmlContent = response;
                const dialogData = {
                    usersList: [this.requestService.selectedRequest.requestor?.email],
                    userListKey: '',
                    contentURL: ApiRoutes.QuoteConfirmEmailUrl,
                    contentKeys: {
                        to_emails: '',
                        subject: (mailType == 'quote' ? 'Quote is ready for Request No: ' : 'Booking Confirmed for Request No: ') + this.requestService.selectedRequest.request_number,
                        content: htmlContent
                    },
                    mailType: mailType,
                    snackBarMessage: snackBarMessage
                };
                const dialogRef = this.dialog.open(SendEmailConfirmationComponent, {
                    width: '80%', // Set the width of the dialog
                    disableClose: true,
                    data: dialogData
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        console.log('User clicked Yes');
                        this.closeReview.emit(true);
                        this.disableSaveButton = false;
                    } else {
                        this.disableSaveButton = false;
                        this.closeReview.emit(true);
                    }
                });

                dialogRef.componentInstance.emailSend.subscribe(() => {
                    this.closeReview.emit(true);
                });
            },
            (error) => {
                console.error('Error fetching HTML content:', error);
            }
        );
    }

    confirmBooking() {
        this.disableSaveButton = true;
        if (this.requestService.selectedRequest.request_type.dev_name == 'one_way') {
            this.oneWayQuoteTableService.baseQuote.remarks = this.remarks;

            this.oneWayQuoteTableService.confirmBooking().then(data => {
                this.openSendQuoteConfirmationDialog(data['latest_quote_id'], 'oneway', 'Smart contract shared on email', 'booking');
                // this.closeReview.emit(true);
            }).catch(error => {
                console.log("error", error)
                if ('requestor' in error.error) {
                    let label = 'Customer KYC Pending'
                    let desc = ''
                    error.error.requestor.forEach(item => {
                        desc += `• ${item}\n`
                    })
                    this.openDialogOnError(label, desc);

                } else {
                    if ('sales_person' in error.error) {
                        this.openWarningEditRequest('Enter the sales person name to proceed further.', '', 'Ok');
                    }
                    this.closeReview.emit(false);
                }
            });
        }
        if (this.requestService.selectedRequest.request_type.dev_name == 'buy_sell') {
            this.tradeQuoteTableService.baseQuote.remarks = this.remarks;

            this.tradeQuoteTableService.confirmBooking().then(data => {
                this.openSendQuoteConfirmationDialog(data['latest_quote_id'], 'trade', 'Smart contract shared on email', 'booking');
                // this.closeReview.emit(true);
            }).catch(error => {
                if ('requestor' in error.error) {
                    let label = 'Customer KYC Pending'
                    let desc = ''
                    error.error.requestor.forEach(item => {
                        desc += `• ${item}\n`
                    })
                    this.openDialogOnError(label, desc)
                } else {
                    if ('sales_person' in error.error) {
                        this.openWarningEditRequest('Enter the sales person name to proceed further.', '', 'Ok');
                    }
                    this.closeReview.emit(false);
                }
            });
        }
    }

    downloadQuote(quote) {
        if (this.requestService.selectedRequest.request_type.dev_name == 'one_way') {
            window.open(`${this.downloadUrl}request_quotes/pdf/oneway/${quote.id}/`, '_blank')
        }
        if (this.requestService.selectedRequest.request_type.dev_name == 'buy_sell') {
            window.open(`${this.downloadUrl}request_quotes/pdf/trade/${quote.id}/`, '_blank')
        }
    }

    backToQuote() {
        this.closeReview.emit(false);
    }

    openDialogOnError(label, description) {
        const dialogRef = this.dialog.open(FailureBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, description: description}
        });

        dialogRef.afterClosed().subscribe(item => {
            let baseUrl = window.location.href.replace(this.router.url, '');
            window.open(`${baseUrl}/master-data/customer-master?id=${this.requestService.selectedRequest.requestor?.company?.id}`, '_blank')
            this.closeReview.emit(false);
        })
    }

    openWarning(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });
    }

    openWarningEditRequest(label: string, description, action1: string, action2?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });

        dialogRef.afterClosed().subscribe(item => {
            this.requestServeComponent.editRequest();
        })
    }

    editQuote(quote: any) {
        quote.edit = true;
        this.edit = true;
    }

    updateQuote(quote: any, type: string) {
        // const req = this.bookingDetails.requirements.filter(item => item.requirement == quote.requirement);
        if (type == 'one_way') {
            this.requestService.postQuantityAndLocations(quote.id, {
                quantity: quote.quantity,
                condition: quote.condition?.id,
                container_size_type: quote?.container_size_type?.id,
                pol_list: quote.pol_list.map(item => item?.id),
                pod_list: quote.pod_list.map(item => item?.id),
            }).subscribe({
                next: response => {
                    this.snackBar.open('Data Saved Successfully', 'Close', {
                        verticalPosition: 'top',
                        duration: 3000,
                    });
                    console.log('postQuotations', response);
                    quote.editQuantity = false;
                    quote.editPOL = false;
                    quote.editPOD = false;
                    quote.editCondition = false;
                    quote.editContainerSizeType = false;
                    this.edit = false;
                    this.bookingChargesComponent.ngOnInit();
                },
                error: err => {
                    return this.catchError(err);
                    // this.extractErrorsFromApi(err.error);
                    // this.openWarningDialog(this.allErrorsFromApi.toString(), '', 'Ok');
            
                }
            });
        } else {
            this.requestService.postQuantityAndLocations(quote.id, {
                quantity: quote.quantity,
                condition: quote.condition?.id,
                container_size_type: quote?.container_size_type?.id,
                pol_list: quote.pol_list.map(item => item?.id)
            }).subscribe({
                next: response => {
                    this.snackBar.open('Data Saved Successfully', 'Close', {
                        verticalPosition: 'top',
                        duration: 3000,
                    });
                    console.log('postQuotations', response);
                    quote.editQuantity = false;
                    quote.editPOL = false;
                    quote.editCondition = false;
                    quote.editContainerSizeType = false;
                    this.edit = false;
                    this.bookingChargesComponent.ngOnInit();
                },
                error: err => {
                    this.extractErrorsFromApi(err.error);
                    this.openWarningDialog(this.allErrorsFromApi.toString(), '', 'Ok');
                    // this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
                    //     verticalPosition: 'top',
                    //     duration: 5000,
                    // });
                }
            });
        }
    }

    getBookingCharges(event) {
        event.map((booking: any) => {
            booking.requirement_charges.map((requirement: any) => {
                this.additionalCharges.push({
                    charge_name: booking.charge_description,
                    currency: booking.currency,
                    requirement: requirement,
                })
            })
        });

        console.log('bookingDetails', this.bookingDetails);
        console.log('additionalCharges', this.additionalCharges);

        this.bookingDetails.requirements.map((requirement: any) => {
            requirement.additionalCharges = [];
        });

        this.bookingDetails.requirements.map((requirement: any) => {
            this.additionalCharges.map((additionalCharge: any) => {
                if (additionalCharge?.requirement?.requirement == requirement?.requirement) {
                    requirement.additionalCharges.push(additionalCharge);
                }
            })
        });
        console.log('bookingDetails', this.bookingDetails);
    }

    showContainers(data: any) {
        this.reqContainers.emit(data);
    }

    extractErrorsFromApi(obj: any) {
        this.allErrorsFromApi = [];
        Object.keys(obj).forEach(key => {
            this.allErrorsFromApi = this.allErrorsFromApi.concat(obj[key]);
        });
    }

    openWarningDialog(label: string, description, action1: string, action2?: string, action3: string = null) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {
                subTitle: label,
                parent: this,
                description: description,
                label1: action1,
                label2: action2,
                label3: action3
            }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
            }
        })
    }

    reset() {
        this.requestServeComponent.getBookingDetails(this.requestService.selectedRequest.booking);
    }
    globalPreference:any;
    getGlobalPreferences() {
        this.requestService.getGlobalPreferences().subscribe(response => {
            this.globalPreference = response;
        })
        console.log("isRebookingAllowed():", this.isRebookingAllowed());
    }

    isRebookingAllowed(): boolean {
        const request = this.requestService.selectedRequest;
        const validityDays = this.globalPreference?.booking__reopen_booking_validity_days || 0;

        if (!request?.booking_closed_at) {
            return false;
        }

        const bookingClosedAt = new Date(request.booking_closed_at);
        const lastValidDate = new Date(bookingClosedAt);
        lastValidDate.setDate(lastValidDate.getDate() + validityDays);

        return new Date() <= lastValidDate; // Show only if today is within the validity period
    }
    showReopenLogs() {
        this.reopenLogs.emit();
    }
    viewLogs(){
        this.bookingViewLogs.emit();
    }
    invoiceParty(data: any) {
        this.addInvoiceParty.emit(data);
    }
  errorObj: any = {};

    catchError(error) {
        if (error.status >= 500) {
            this.errorObj = { ...error.error };
            return error;
        } else if (error.status > 399 && error.status < 500) {
            this.errorObj = { ...error.error,
                ...this.errorObj, // retain previous errors
             };
            return error;
        }
    }

    postBookingQuantity(requirement) {
        let payload={
            quantity : requirement.quantity
        }
        this.requestService.updateBookingQuantity( requirement.id, payload).subscribe({
            next: response => {
                this.bookingChargesComponent.ngOnInit();
                requirement.editQuantity = false
                this.snackBar.open("Quantity Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err);
            }
        })
    }

    postContainerSizeType(requirement) {
        let payload = {
            container_size_type : requirement.container_size_type ? requirement.container_size_type?.id : null
        }
        this.requestService.updateContainerSizeType( requirement.id,payload).subscribe({
            next: response => {
                this.bookingChargesComponent.ngOnInit();
                requirement.editContainerSizeType = false
                this.snackBar.open("Sized Type Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err);
            }
        })
    }

    postBookingLocation(requirement) {
        let payload={
            pol_list : requirement.pol_list.map(item => item?.id),
            pod_list : requirement.pod_list.map(item => item?.id)
        }
        this.requestService.updateBookingLocation(requirement.id,payload).subscribe({
            next: response => {
                this.bookingChargesComponent.ngOnInit();
                requirement.editPOL = false
                requirement.editPOD = false

                this.snackBar.open("Location Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err);
            }
        })
    }

    postOnewayfreedaysPerdiem(data) {
        let payload = {
            min_per_diem_free_days : data.min_per_diem_free_days,
            max_per_diem_free_days : data.max_per_diem_free_days,
            min_per_diem : data.min_per_diem,
            min_per_diem_currency : data.min_per_diem_currency,
            max_per_diem : data.max_per_diem,
            max_per_diem_currency : data.max_per_diem_currency
        }
        this.requestService.updateOnewayfreedaysPerdiem( data.id,payload).subscribe({
            next: response => {
                this.bookingChargesComponent.ngOnInit();
                data.editPerDiemCharge = false
                data.editMaxPerDiemCharge = false
                data.editMaxFreeDays = false
                data.editMinFreeDays = false

                this.snackBar.open("Free days and per diem Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                });
            },
            error: err => {
                return this.catchError(err);
            }
        })
    }
    saveRequirement() {
        const req = this.bookingDetails.requirements[0];

        if (req.editQuantity) {
            this.postBookingQuantity(req);
            // req.editQuantity = false;
        }
        if (req.editContainerSizeType) {
            this.postContainerSizeType(req);
            // req.editContainerSizeType = false;
        }
        if (req.editPOL || req.editPOD) {
            this.postBookingLocation(req);
            // req.editPOL = false;
            // req.editPOD = false;

        }
        if (req.editPerDiemCharge || req.editMaxPerDiemCharge || req.editMaxFreeDays || req.editMinFreeDays) {
            this.postOnewayfreedaysPerdiem(req);
            // req.editPerDiemCharge = false;
        }
    }
      
}
